const API_URL = process.env.API_URL || 'http://localhost:3000';

export default function getAvatarFilter (){
  'ngInject';
  return ( input , data ) => {
    try{
      let avatar = input.uris.Avatar;
      return `${API_URL}${avatar}${avatar.indexOf('timestamp') === -1 ? '?' : '&'}s=200`;
    } catch( e ){
      return '';
    }
  }
}


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/get-avatar/get-avatar.filter.js
 **/